import { EmptyState, Symbols } from '@mnd-frontend/ui';
import { useTranslation } from 'react-i18next';

const NoImagesFound = () => {
  const [t] = useTranslation();
  return (
    <EmptyState
      symbol={Symbols.Newspaper}
      headline={t('publish_pr-edit_image-bank-gallery_messenger-empty-title')}
      description={t('publish_pr-edit_image-bank-gallery_messenger-empty-description')}
    />
  );
};

export default NoImagesFound;
